import * as queryString from 'query-string'
import { ArrayUtils } from '@shopping/common'
import { BrandAggregate } from 'common/types/entities/mongo/brandAggregate'
import { fetchBrandsByIds } from 'common/services/brandSearch'
import { SubVertical } from 'common/constants'
import { deleteBrandZzim, fetchBrandZzims } from 'common/services/zzim'
import { isBrowser } from 'common/utils'
import { isIe9 } from 'common/utils/oldIeVersion'
import history from 'common/history'
import { setLocationKept } from 'common/ducks/locationKept'

export interface BrandSelect {
  selectedBrands: BrandAggregate[]
  appliedBrands: BrandAggregate[]
  myBrands: BrandAggregate[]
}

const emptyBrandArray: BrandAggregate[] = []

const initialBrand: BrandSelect = {
  selectedBrands: emptyBrandArray,
  appliedBrands: emptyBrandArray,
  myBrands: emptyBrandArray,
}

const MAX_SELECT_BRAND = 5

const ADD_BRAND = 'brand/ADD_BRAND'
const REMOVE_SELECTED_BRAND = 'brand/REMOVE_SELECTED_BRAND'
const REMOVE_APPLIED_BRAND = 'brand/REMOVE_APPLIED_BRAND'
const APPLY_BRAND = 'brand/APPLY_BRAND'
const INIT_SELECTED_BRAND = 'brand/INIT_SELECTED_BRAND'
const INIT_APPLIED_BRAND = 'brand/INIT_APPLIED_BRAND'
const INIT_MY_BRAND = 'brand/INIT_MY_BRAND'
const INIT = 'brand/INIT'
const FETCH_MY_BRANDS = 'brand/FETCH_MY_BRANDS'
const REMOVE_MY_BRAND = 'brand/REMOVE_MY_BRAND'

export const addSelectedBrand = (brand: BrandAggregate) => {
  return {
    brand,
    type: ADD_BRAND,
  }
}

export const removeSelectedBrand = (id: string) => {
  return {
    id,
    type: REMOVE_SELECTED_BRAND,
  }
}

export const removeAppliedBrand = (id: string) => {
  return {
    id,
    type: REMOVE_APPLIED_BRAND,
  }
}

export const applySelectedBrands = () => {
  return {
    type: APPLY_BRAND,
  }
}

export const initSelectedBrands = (selectedBrands: BrandAggregate[]) => {
  return {
    selectedBrands,
    type: INIT_SELECTED_BRAND,
  }
}

export const initAppliedBrands = (subVertical: SubVertical, brandIds: string[]) => async dispatch => {
  const brands = await fetchBrandsByIds(subVertical, brandIds)
  dispatch({
    selectedBrands: brands || emptyBrandArray,
    appliedBrands: brands || emptyBrandArray,
    type: INIT_APPLIED_BRAND,
  })
}

export const initializeBrands = () => ({ type: INIT })

export const initMyBrands = () => ({ type: INIT })

export const fetchMyBrands = (subVertical: SubVertical) => async dispatch => {
  const brands = (await fetchBrandZzims(subVertical)) || []
  dispatch({
    brands,
    type: FETCH_MY_BRANDS,
  })
}

export const removeMyBrand = (brandId: string) => async dispatch => {
  await deleteBrandZzim(brandId)

  dispatch({
    id: brandId,
    type: REMOVE_MY_BRAND,
  })
}

export const isMaxSelectedBrands = (brands: BrandAggregate[], newBrand: BrandAggregate) => {
  const hasBrand = brands.some(item => item._id === newBrand._id)
  const countSelectd = brands.length + 1

  return hasBrand ? false : countSelectd > MAX_SELECT_BRAND
}

export const getUniqueBrands = (brands: BrandAggregate[], newBrand: BrandAggregate) => {
  const hasBrand = brands.some(item => item._id === newBrand._id)
  if (hasBrand) {
    return brands
  }

  if (brands.length >= MAX_SELECT_BRAND) {
    alert('최대 5개까지만 선택할 수 있습니다.')
    return brands
  }

  return [...brands, newBrand]
}

export const applyBrandsOnUrl = (brandIds: string[]) => async dispatch => {
  if (!isBrowser) return

  const queryParam = queryString.parse(window.location.search)
  if (ArrayUtils.isNotEmpty(brandIds)) {
    queryParam.brands = brandIds.join(',')
  } else {
    delete queryParam.brands
  }
  const url = `${window.location.pathname}?${queryString.stringify(queryParam)}`
  dispatch(setLocationKept(true))
  !isIe9() && history.replace(url)
}

const brandReducer = (state = initialBrand, action) => {
  switch (action.type) {
    case ADD_BRAND:
      return {
        ...state,
        selectedBrands: getUniqueBrands(state.selectedBrands, action.brand),
      }
    case REMOVE_SELECTED_BRAND:
      return {
        ...state,
        selectedBrands: state.selectedBrands.filter(item => item._id !== action.id),
      }
    case REMOVE_APPLIED_BRAND:
      return {
        ...state,
        appliedBrands: state.appliedBrands.filter(item => item._id !== action.id),
      }
    case APPLY_BRAND:
      return {
        ...state,
        appliedBrands: state.selectedBrands,
      }
    case INIT_SELECTED_BRAND:
      return {
        ...state,
        selectedBrands: action.selectedBrands,
      }
    case INIT_APPLIED_BRAND:
      return {
        ...state,
        ...action,
      }
    case INIT:
      return initialBrand
    case INIT_MY_BRAND:
      return {
        ...state,
        myBrands: emptyBrandArray,
      }
    case FETCH_MY_BRANDS:
      return {
        ...state,
        myBrands: action.brands,
      }
    case REMOVE_MY_BRAND:
      return {
        ...state,
        myBrands: state.myBrands.filter(item => item._id !== action.id),
      }
    default:
      return state
  }
}

export default brandReducer
